export const translations = {
    es: {
        navbar: {
            home: "Inicio",
            about: "Acerca de",
            services: "Servicios",
            contact: "Contacto",
            join: "Únete",
            calendar: "Innovación, datos y tecnología para hacer crecer tu empresa. Conoce cómo nuestras soluciones pueden optimizar tu empresa.",
            boton: 'Asesoría gratuita'
        },
        solutionsIntro: {
            line1: "SEGURO,",
            line2: "CONFIABLE,",
            line3: "SOLUCIONES",
            highlight: "ESCALABLES.",
            description: "Servicios de tecnología de la información en todos los Estados Unidos",
            buttons: {
                about: "Sobre Nosotros",
                services: "Nuestros Servicios"
            }
        },
        hero: {
            title_part1: "¿Diriges un negocio en el ",
            title_highlight: "mundo digital actual?",
            paragraph: [
                "Cuando la tecnología falla, ocurren brechas de comunicación, retrasos operativos, fallas en el sistema o incidentes de ciberseguridad, y el rendimiento de tu empresa puede verse afectado.",
                "<strong>Ahí es donde entra CastleTech LLC.</strong>",
                "Somos un socio tecnológico impulsado por los negocios, gestionando proactivamente tu infraestructura, sistemas de seguridad y redes de comunicación para mantener tus operaciones seguras, confiables y escalables.",
                "Aliarte con CastleTech significa tener un equipo de tecnología dedicado que monitorea, protege y mantiene tus sistemas, previniendo problemas antes de que impacten tu negocio.",
                "Y si surgen inconvenientes, los resolvemos rápidamente, a menudo sin que lo notes, para que puedas concentrarte en hacer crecer tu empresa."
            ]
        },
        about: {
            title: "Sobre Nosotros",
            description: "Somos expertos en transformación digital y soluciones en la nube.",
            title_part1: "SOBRE ",
            title_highlight: "NOSOTROS"
        },
        services: {
            title: "Nuestros Servicios",
            list: ["Infraestructura Cloud", "Desarrollo Personalizado", "Ciberseguridad"]
        },
        contact: {
            title: "Contáctanos",
            subtitle: "Escríbenos y nos pondremos en contacto contigo pronto.",
            name: "Tu nombre",
            email: "Tu correo",
            message: "Tu mensaje",
            send: "Enviar"
        },
        why: {
            title_part1: "¿POR QUÉ ",
            title_highlight: "ELEGIRNOS?",
            description: "Servicios de tecnología de la información en todos los Estados Unidos",
            cards: [
                {
                    icon: "/images/secure-blue.svg",
                    title: "SEGURO",
                    subtitle: "¿Tu red empresarial es realmente segura?",
                    text: "En el entorno actual, las filtraciones de datos, el ransomware y los ciberataques son amenazas diarias para las pequeñas y medianas empresas en todos los sectores.<br>CastleTech LLC ofrece soluciones proactivas de ciberseguridad para prevenir intrusiones, proteger datos sensibles y garantizar la continuidad del negocio, para que puedas operar con confianza y tranquilidad.<br>Tu empresa merece más que solo protección básica: merece una estrategia. Mantente seguro. Mantente adelante. Sé imparable con CastleTech LLC.",
                    spanClass: "text-span-5"
                },
                {
                    icon: "/images/user-blue.svg",
                    title: "CONFIABLE",
                    subtitle: "Tecnología en la que puedes confiar.",
                    text: "En los negocios, la confiabilidad no es opcional: es esencial. Ya sea tu red, sistemas en la nube, herramientas de comunicación o acceso a datos, tu tecnología debe funcionar — siempre.<br>Nuestro mantenimiento proactivo, monitoreo 24/7 y soporte de respuesta rápida aseguran que tu negocio funcione sin interrupciones.<br>Con CastleTech, cuentas con un socio tecnológico comprometido con brindar un rendimiento confiable, constante — día tras día.",
                    spanClass: "text-span-6"
                },
                {
                    icon: "/images/graph-blue.svg",
                    title: "SOLUCIONES ESCALABLES",
                    subtitle: "Tecnología que crece contigo.",
                    text: "Ya sea que estés ampliando tu equipo, abriendo nuevas ubicaciones o adaptándote a demandas digitales, tu tecnología debe escalar junto a tu negocio.<br>CastleTech LLC diseña e implementa soluciones en la nube escalables que apoyan tu crecimiento sin interrumpir las operaciones.<br>Desde infraestructura segura en la nube y escritorios virtuales hasta almacenamiento y herramientas colaborativas, ayudamos a las empresas a evolucionar con confianza y flexibilidad.<br>A medida que tu negocio crece, CastleTech se asegura de que tu tecnología esté a la altura — de forma confiable, segura y eficiente.",
                    spanClass: "text-span-7"
                }
            ]
        },
        servicesList: {
            title_part1: "OTROS ",
            title_highlight: "SERVICIOS",
            description: "Servicios de tecnología de la información en todos los Estados Unidos",
            items: [
                {
                    icon: "/images/cloud-blue.svg",
                    title: "INFRAESTRUCTURA EN LA NUBE Y MIGRACIÓN",
                    text: "Ayudamos a tu empresa a migrar cargas de trabajo a la nube de forma segura y escalable. Ofrecemos servicios en AWS, Azure y Google Cloud, garantizando alta disponibilidad, continuidad operativa y optimización de costos."
                },
                {
                    icon: "/images/cloud-blue.svg",
                    title: "CIBERSEGURIDAD Y CUMPLIMIENTO",
                    text: "Protege tus sistemas críticos con nuestros servicios de seguridad TI. Implementamos firewalls, monitoreo continuo, gestión de vulnerabilidades y cumplimiento de normativas como GDPR, ISO 27001 y PCI-DSS."
                },
                {
                    icon: "/images/cloud-blue.svg",
                    title: "SERVICIOS DE TI GESTIONADOS",
                    text: "Brindamos soporte continuo 24/7 a tu infraestructura TI. Nuestro equipo actúa como tu departamento de TI externo, manejando mantenimiento, monitoreo y soporte técnico."
                },
                {
                    icon: "/images/computer-blue.svg",
                    title: "DESARROLLO DE SOFTWARE PERSONALIZADO",
                    text: "Desarrollamos soluciones a medida adaptadas a los procesos de tu negocio. Desde sistemas internos hasta aplicaciones móviles y web, garantizamos eficiencia, escalabilidad y una excelente experiencia de usuario."
                },
                {
                    icon: "/images/cloud-blue.svg",
                    title: "SOLUCIONES FINTECH E INTEGRACIÓN",
                    text: "Diseñamos e integramos soluciones tecnológicas para el sector financiero, incluyendo pasarelas de pago, remesas, billeteras digitales, herramientas KYC/AML y paneles de análisis en tiempo real para la toma de decisiones."
                },
                {
                    icon: "/images/users-blue.svg",
                    title: "ANALÍTICA DE DATOS E INTELIGENCIA DE NEGOCIO",
                    text: "Libera el poder de tus datos con nuestras soluciones de inteligencia de negocios. Implementamos paneles en Power BI, automatizamos reportes y desarrollamos modelos predictivos para optimizar tus decisiones estratégicas."
                },
                {
                    icon: "/images/consulting-blue.svg",
                    title: "CONSULTORÍA TI Y TRANSFORMACIÓN DIGITAL",
                    text: "Guiamos tu proceso de transformación digital con estrategias enfocadas en tecnología, eficiencia operativa y automatización. Brindamos soporte desde la arquitectura hasta la implementación."
                },
                {
                    icon: "/images/grafh-blue.svg",
                    title: "CAPACITACIÓN EN NUBE, SEGURIDAD Y LIDERAZGO TECNOLÓGICO",
                    text: "Ofrecemos programas de capacitación personalizados en liderazgo tecnológico, ciberseguridad, computación en la nube y herramientas clave como Microsoft 365, Power BI y DevOps para ayudar a tu equipo a mantenerse competitivo."
                },
                {
                    icon: "/images/cloud-blue.svg",
                    title: "ACADEMIA DE DESARROLLADORES E INCUBACIÓN DE TALENTO",
                    text: `Formamos a la próxima generación de desarrolladores de software a través de programas prácticos enfocados en proyectos reales. Nuestra academia ofrece bootcamps, mentorías y rutas de preparación para el trabajo en desarrollo full-stack, nube y DevOps.
                    <br><br>Además, identificamos a los estudiantes con mejor desempeño para integrarlos en proyectos reales con clientes, acelerando su crecimiento y proporcionando talento fresco a nuestros socios.Además, identificamos a los estudiantes con mejor desempeño para integrarlos en proyectos reales con clientes, acelerando su crecimiento y proporcionando talento fresco a nuestros socios.`
                }
            ]
        },
        empowering: {
            text: "Impulsando tu visión con tecnología."
        },
        partnerStatement: {
            text: "No solo entregamos — somos tu socio."
        },
        aboutPage: {
            title_part1: "SOBRE ",
            title_highlight: "NOSOTROS",
            heading: "Sobre Nosotros – CastleTech LLC",
            description: `CastleTech LLC es una empresa de soluciones tecnológicas especializada en servicios integrales de TI para empresas e instituciones que buscan modernizar sus operaciones mediante el uso estratégico de la tecnología.
            <br><br>Con más de 20 años de experiencia liderando proyectos de infraestructura crítica, transformación digital y automatización de procesos, hemos entregado resultados exitosos en industrias altamente reguladas como fintech, remesas, comercio minorista, telecomunicaciones y servicios financieros. Nuestra experiencia abarca desde el diseño e implementación de arquitecturas en la nube hasta el desarrollo de plataformas transaccionales, billeteras digitales, pasarelas de pago, integraciones de APIs bancarias y ciberseguridad basada en estándares como PCI DSS e ISO 27001.
            <br><br>Nuestro equipo multidisciplinario ha ejecutado proyectos de alto impacto en América Latina y América del Norte, combinando un profundo conocimiento técnico con una mentalidad estratégica orientada a resultados. Desde soluciones en la nube y redes SD-WAN hasta digitalización de servicios financieros y cumplimiento normativo, CastleTech está comprometido con ofrecer eficiencia operativa, escalabilidad y sostenibilidad tecnológica a largo plazo.
            <br><br>Nos impulsa la innovación, la calidad y las alianzas duraderas. En CastleTech, creemos que la tecnología debe ser un catalizador del crecimiento, no una barrera, y ofrecemos soluciones a medida que alinean la tecnología, los procesos y la visión empresarial.`,
            mission_title: "MISIÓN",
            mission_text: "Brindar soluciones tecnológicas innovadoras, seguras y eficientes que impulsen la transformación digital de empresas e instituciones, integrando infraestructura, desarrollo de software, automatización de procesos y servicios fintech, mediante un enfoque personalizado alineado con los objetivos estratégicos de cada cliente.",
            vision_title: "VISIÓN",
            vision_text: "Convertirse en una empresa líder en las Américas, reconocida por su excelencia técnica, innovación y fuerte compromiso con el crecimiento sostenible de sus clientes; posicionándonos como un aliado estratégico en la evolución tecnológica de organizaciones que buscan eficiencia, seguridad y transformación digital.",
            closing_phrase: "Tu misión es nuestro compromiso."
        },
        footer: {
            email: "info@castletechllc.com",
            address: "4778 SW 131st Place Ocala, FL 34473",
            phone: "(352) 445-8883"
        },
        contactSection: {
            header: "CONTÁCTANOS",
            subtitle: "Ponte en contacto",
            fields: {
                name: "Tu nombre",
                email: "Tu correo",
                subject: "Asunto",
                message: "Escribe un mensaje"
            },
            button: "Enviar",
            success: "¡Gracias! Tu mensaje ha sido recibido.",
            error: "Ups. Algo salió mal al enviar el formulario.",
            info: {
                email: "info@castletechllc.com",
                address: "4778 SW 131st Place Ocala, FL 34473",
                phone: "(352) 445-8883"
            },
            errors: {
                name: "El nombre solo puede contener letras.",
                email: "Correo electrónico inválido.",
                subject: "El asunto debe tener al menos 3 caracteres.",
                message: "El mensaje debe tener al menos 10 caracteres."
            }
        },
        joinTeam: {
            header_part1: "ÚNETE AL",
            header_part2: "EQUIPO",
            subtitle: "POSTÚLATE AHORA",
            form: {
                firstName: "Nombre",
                lastName: "Apellido",
                phone: "Teléfono",
                email: "Correo Electrónico",
                description: "Escribe un mensaje",
                cv: "Adjunta tu CV",
                submit: "Enviar",
                success: "¡Gracias! Tu solicitud ha sido recibida.",
                error: "Ups. Algo salió mal al enviar el formulario.",
                errors: {
                    firstName: "El nombre solo debe contener letras.",
                    lastName: "El apellido solo debe contener letras.",
                    phone: "Número de teléfono inválido.",
                    email: "Dirección de correo electrónico inválida.",
                    message: "El mensaje debe tener al menos 10 caracteres.",
                    cv: "El CV debe ser un archivo en formato PDF.",
                }

            },
            promo: {
                title: `¿Te apasiona la <span class="text-span-4">ciberseguridad</span> y  <span class="text-span-4">estás listo para nuevos retos</span>?`,
                description: `Únete a un equipo que valora la innovación, la colaboración y el aprendizaje continuo. Buscamos profesionales curiosos, proactivos y comprometidos con crear entornos digitales más seguros.<br><br>Ya sea que tengas experiencia o estés comenzando tu carrera, ofrecemos oportunidades para crecer, contribuir y generar un impacto real.<br><br>Sé parte de algo más grande. Postúlate ahora y ayúdanos a dar forma al futuro de la ciberseguridad.`
            }
        },
        feedback: {
            loading: 'Procesando...',
            success: 'Operación completada correctamente.',
            error: 'Ha ocurrido un error. Inténtalo más tarde.',
            warning: 'Por favor revisa los datos ingresados.',
        },
    },
    en: {
        navbar: {
            home: "Home",
            about: "About",
            services: "Services",
            contact: "Contact",
            join: "Join",
            calendar: "Innovation, data and technology to grow your company. Learn how our solutions can optimize your company.",
            boton: 'Free Consultation'
        },
        solutionsIntro: {
            line1: "SECURE,",
            line2: "RELIABLE,",
            line3: "SCALABLE",
            highlight: "SOLUTIONS.",
            description: "Information Technology Services Across the United States",
            buttons: {
                about: "About Us",
                services: "Our Services"
            }
        },
        hero: {
            title_part1: "Running a business in today’s ",
            title_highlight: "Digital World?",
            paragraph: [
                "When technology slows down, communication gaps, operational delays, system failures, or cybersecurity incidents occur, your business performance can suffer.",
                "<strong>That’s where CastleTech LLC comes in.</strong>",
                "We are a business-driven technology partner, proactively managing your infrastructure, security systems, and communication networks to keep your operations secure, reliable, and scalable.",
                "Partnering with CastleTech means having a dedicated technology team that monitors, protects, and maintains your systems — preventing problems and threats before they impact your business.",
                "And if issues arise, we resolve them swiftly and often behind the scenes, so you can stay focused on growing your company."
            ]
        },
        about: {
            title: "About Us",
            description: "We specialize in digital transformation and cloud solutions.",
            title_part1: "ABOUT ",
            title_highlight: "US"
        },
        services: {
            title: "Our Services",
            list: ["Cloud Infrastructure", "Custom Development", "Cybersecurity"]
        },
        contact: {
            title: "Contact Us",
            subtitle: "Send us a message and we’ll get back to you soon.",
            name: "Your name",
            email: "Your email",
            message: "Your message",
            send: "Send"
        },
        why: {
            title_part1: "WHY ",
            title_highlight: "CHOOSE US?",
            description: "Information Technology Services Across the United States",
            cards: [
                {
                    icon: "/images/secure-blue.svg",
                    title: "SECURE",
                    subtitle: "Is Your Business Network Truly Secure?",
                    text: "In today’s environment, data breaches, ransomware, and cyberattacks have become daily threats to small and medium businesses across all sectors.<br>CastleTech LLC provides proactive cybersecurity solutions to prevent intrusions, protect sensitive data, and ensure business continuity — so you can operate with confidence and peace of mind.<br>Your business deserves more than just basic protection — it deserves a strategy. Stay secure. Stay ahead. Stay unstoppable with CastleTech LLC.",
                    spanClass: "text-span-5"
                },
                {
                    icon: "/images/user-blue.svg",
                    title: "RELIABLE",
                    subtitle: "Technology You Can Depend On.",
                    text: "In business, reliability isn’t optional — it’s essential. Whether it's your network, cloud systems, communication tools, or data access, your technology must perform — every time.<br>Our proactive maintenance, 24/7 monitoring, and rapid-response support ensure your business runs smoothly without interruption.<br>With CastleTech, you're backed by a technology partner committed to delivering consistent, reliable performance — day after day.",
                    spanClass: "text-span-6"
                },
                {
                    icon: "/images/graph-blue.svg",
                    title: "SCALABLE SOLUTIONS",
                    subtitle: "Technology That Grows With You.",
                    text: "Whether you're expanding your team, opening new locations, or adapting to new digital demands — your technology must scale with your business.<br>CastleTech LLC designs and deploys scalable cloud-based solutions that support your growth, without disrupting operations.<br>From secure cloud infrastructure and virtual desktops to scalable storage and collaboration tools, we help businesses evolve with confidence and flexibility.<br>As your business grows, CastleTech ensures your technology keeps up — reliably, securely, and efficiently.",
                    spanClass: "text-span-7"
                }
            ]
        },
        servicesList: {
            title_part1: "OTHER ",
            title_highlight: "SERVICES",
            description: "Information Technology Services Across the United States",
            items: [
                {
                    icon: "/images/cloud-blue.svg",
                    title: "CLOUD INFRASTRUCTURE & MIGRATION",
                    text: "We help your company migrate workloads to the cloud securely and scalably. We offer services on AWS, Azure, and Google Cloud, ensuring high availability, business continuity, and cost optimization."
                },
                {
                    icon: "/images/cloud-blue.svg",
                    title: "CYBERSECURITY & COMPLIANCE",
                    text: "Protect your critical systems with our IT security services. We implement firewalls, continuous monitoring, vulnerability management, and compliance with regulations such as GDPR, ISO 27001, and PCI-DSS."
                },
                {
                    icon: "/images/cloud-blue.svg",
                    title: "MANAGED IT SERVICES",
                    text: "We provide 24/7 ongoing support for your IT infrastructure. Our team acts as your external IT department, handling maintenance, monitoring, technical support, and incident management."
                },
                {
                    icon: "/images/computer-blue.svg",
                    title: "CUSTOMIZED SOFTWARE DEVELOPMENT",
                    text: "We develop tailored solutions adapted to your business processes. From internal systems to mobile and web applications, we ensure efficiency, scalability, and an excellent user experience."
                },
                {
                    icon: "/images/cloud-blue.svg",
                    title: "FINTECH SOLUTIONS & INTEGRATION",
                    text: "We design and integrate technology solutions for the financial sector, including payment gateways, remittances, digital wallets, KYC/AML tools, and real-time analytics dashboards for decision-making."
                },
                {
                    icon: "/images/users-blue.svg",
                    title: "DATA ANALYTICS & BUSINESS INTELLIGENCE",
                    text: "Unlock the power of your data with our business intelligence solutions. We implement Power BI dashboards, automate reporting, and build predictive models to optimize your strategic decisions."
                },
                {
                    icon: "/images/consulting-blue.svg",
                    title: "IT CONSULTING & DIGITAL TRANSFORMATION",
                    text: "We guide your digital transformation process with strategies focused on technology, operational efficiency, and automation. We support everything from architecture to implementation."
                },
                {
                    icon: "/images/grafh-blue.svg",
                    title: "TRAINING IN CLOUD, SECURITY & TECH LEADERSHIP",
                    text: "We offer personalized training programs in tech leadership, cybersecurity, cloud computing, and key tools such as Microsoft 365, Power BI, and DevOps to help your team stay competitive."
                },
                {
                    icon: "/images/cloud-blue.svg",
                    title: "DEVELOPER ACADEMY & TALENT INCUBATION",
                    text: `We train the next generation of software developers through hands-on programs focused on real-world projects. Our academy offers bootcamps, mentoring, and job-readiness tracks in full-stack development, cloud, and DevOps.
                    <br><br>We also identify top-performing students to integrate them into real client projects, accelerating their growth while providing fresh talent to our partners.`
                }
            ]
        },
        empowering: {
            text: "Empowering Your Vision With Technology."
        },
        partnerStatement: {
            text: "We Don’t Just Deliver — We Partner."
        },
        aboutPage: {
            title_part1: "ABOUT ",
            title_highlight: "US",
            heading: "About Us – CastleTech LLC",
            description: `CastleTech LLC is a technology solutions company specializing in comprehensive IT services for businesses and institutions seeking to modernize their operations through the strategic use of technology. 
            <br><br> With over 20 years of experience leading mission-critical infrastructure, digital transformation, and process automation projects, we have successfully delivered results in highly regulated industries such as fintech, remittances, retail, telecommunications, and financial services. Our expertise spans from cloud architecture design and implementation to the development of transactional platforms, digital wallets, payment gateways, banking API integrations, and cybersecurity based on standards such as PCI DSS and ISO 27001.‍ 
            <br><br>Our multidisciplinary team has executed high-impact projects across Latin America and North America, combining deep technical knowledge with a strategic, results-oriented mindset. From cloud solutions and SD-WAN networks to financial service digitization and regulatory compliance, CastleTech is committed to delivering operational efficiency, scalability, and long-term technological sustainability. <br><br>‍We are driven by innovation, quality, and lasting partnerships. At CastleTech, we believe technology should be a catalyst for growth—not a barrier—and we deliver tailored solutions that align technology, processes, and business vision.`,
            mission_title: "MISSION",
            mission_text: "To deliver innovative, secure, and efficient technology solutions that drive the digital transformation of businesses and institutions by integrating infrastructure, software development, process automation, and fintech services—through a personalized approach aligned with each client’s strategic goals.",
            vision_title: "VISION",
            vision_text: "To become a leading company across the Americas, recognized for technical excellence, innovation, and a strong commitment to our clients' sustainable growth—positioning ourselves as a strategic partner in the technological evolution of organizations seeking efficiency, security, and digital transformation.",
            closing_phrase: "Your Mission Is Our Commitment."
        },
        contactSection: {
            header: "CONTACT US",
            subtitle: "Get in touch",
            fields: {
                name: "Your name",
                email: "Your email",
                subject: "Subject",
                message: "Write a message"
            },
            button: "Submit",
            success: "Thank you! Your submission has been received!",
            error: "Oops! Something went wrong while submitting the form.",
            info: {
                email: "info@castletechllc.com",
                address: "This is some text inside of a div block.",
                phone: "(352) 445-8883"
            },
            errors: {
                name: "Name must contain only letters.",
                email: "Invalid email address.",
                subject: "Subject must be at least 3 characters long.",
                message: "Message must be at least 10 characters long."
            }

        },
        joinTeam: {
            header_part1: "JOIN",
            header_part2: "TEAM",
            subtitle: "APPLY NOW",
            form: {
                firstName: "First Name",
                lastName: "Last Name",
                phone: "Phone",
                email: "Email",
                description: "Write a message",
                cv: "Attach your CV",
                submit: "Submit",
                success: "Thank you! Your submission has been received!",
                error: "Oops! Something went wrong while submitting the form.",
                errors: {
                    firstName: "First name must contain only letters.",
                    lastName: "Last name must contain only letters.",
                    phone: "Invalid phone number.",
                    email: "Invalid email address.",
                    message: "Message must be at least 10 characters.",
                    cv: "CV must be a PDF file.",
                }
            },
            promo: {
                title: `Are you passionate about <span class="text-span-4">cybersecurity</span> and <span class="text-span-4">ready to take on new challenges?</span>`,
                description: `Join a team that values innovation, collaboration, and continuous learning. We’re looking for professionals who are curious, proactive, and committed to creating safer digital environments.<br><br>Whether you're an experienced specialist or just starting your career, we offer opportunities to grow, contribute, and make a real impact.<br><br>Be part of something bigger. Apply now and help us shape the future of cybersecurity.`
            }
        },
        footer: {
            email: "info@castletechllc.com",
            address: "4778 SW 131st Place Ocala, FL 34473",
            phone: "(352) 445-8883"
        },
        feedback: {
            loading: 'Processing...',
            success: 'Operation completed successfully.',
            error: 'An error occurred. Please try again later.',
            warning: 'Please check the entered data.',
        }
    }
};
